import { action } from 'typesafe-actions';

import { PassportGroupActionsEnum } from '../enums/PassportGroupActionsEnum';
import { IPassportGroupCreateRequest } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroupCreateRequest';
import { IPassportGroupShort } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroupShort';
import { IPassportGroupPassport } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroupPassport';
import { IPassportGroup } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroup';
import { IPassportGroupApplyRequest } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroupApplyRequest';
import { IPassportGroupApplyByKnoRequest } from '../../../APIPackage/PassportGroupsModule/interfaces/IPassportGroupApplyByKnoRequest';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { IPassportGroupForm } from '../../PassportGroupFormModule/interfaces/IPassportGroupForm';
import { PassportGroupPassportTypeEnum } from '../../PassportGroupFormModule/enums/PassportGroupPassportTypeEnum';
import { IKnmAttachment } from '../../../APIPackage/KnmModule/interfaces/IKnmAttachment';
import { ExportFormatsEnum } from '../../../APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { PassportGroupTypeEnum } from '../../../APIPackage/PassportGroupsModule/enums/PassportGroupTypeEnum';

export const passportGroupCreateAction = (data: IPassportGroupCreateRequest) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_CREATE, { data });
export const passportGroupGetPageAction = (type: PassportGroupTypeEnum, reasonId: number | undefined) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_GET_PAGE, { type, reasonId });
export const passportGroupGetNextPageAction = (type: PassportGroupTypeEnum, reasonId: number | undefined) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_GET_NEXT_PAGE, { type, reasonId });
export const passportGroupSetListAction = (data: IPassportGroupShort[]) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_LIST, { data });
export const passportGroupSetListTotalCountAction = (value: number) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_TOTAL_COUNT, { value });
export const passportGroupSetListCurrentPageAction = (value: number) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_CURRENT_PAGE, { value });
export const passportGroupPassportGetPageAction = (groupId: number | string) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_GET_PAGE, { groupId });
export const passportGroupPassportGetNextPageAction = (groupId: number | string) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_GET_NEXT_PAGE, { groupId });
export const passportGroupPassportSetListAction = (data: IPassportGroupPassport[]) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_SET_LIST, { data });
export const passportGroupPassportSetTotalCountAction = (value: number) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_SET_TOTAL_COUNT, { value });
export const passportGroupPassportSetCurrentPageAction = (value: number) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_SET_CURRENT_PAGE, { value });
export const passportGroupGetAction = (id: number | string) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_GET, { id });
export const passportGroupSetAction = (data: IPassportGroup | undefined) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET, { data });
export const passportGroupApplyAction = (groupId: number, data: IPassportGroupApplyRequest) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_APPLY, { groupId, data });
export const passportGroupApplyByKnoAction = (groupId: number, data: IPassportGroupApplyByKnoRequest) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_APPLY_BY_KNO, { groupId, data });
export const passportGroupSetApplySuccessAction = (value: boolean) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_APPLY_SUCCESS, { value });
export const passportGroupSetCreateSuccessAction = (value: boolean) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_CREATE_SUCCESS, { value });
export const passportGroupSetNoticeAction = (value: string | undefined) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_NOTICE, { value });
export const passportGroupsGetRiskIndicatorsSelectOptions = (
  query: string,
  callback: (options: ISelectOption[]) => void,
) => action(PassportGroupActionsEnum.PASSPORT_GROUP_GET_RISK_INDICATORS_SELECT_OPTIONS, { query, callback });
export const passportGroupInitDetailFormAction = () => action(PassportGroupActionsEnum.PASSPORT_GROUP_INIT_DETAIL_FORM);
export const passportGroupSetInitFormAction = (data: IPassportGroupForm) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_INIT_FORM, { data });
export const passportGroupPassportApplyByKno = (
  passportId: number,
  passportType: PassportGroupPassportTypeEnum,
  decision: IKnmAttachment,
) => action(PassportGroupActionsEnum.PASSPORT_GROUP_PASSPORT_APPLY_BY_KNO, { passportId, passportType, decision });
export const passportGroupGetIsExistsGroupsForCancellationAction = () =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_GET_IS_EXISTS_GROUPS_FOR_CANCELLATION);
export const passportGroupSetIsExistsGroupsForCancellationAction = (value: boolean) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_IS_EXISTS_GROUPS_FOR_CANCELLATION, { value });
export const passportGroupExportAction = (groupId: number, format: ExportFormatsEnum) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_EXPORT, { groupId, format });
export const passportGroupDeleteAction = (groupId: number) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_DELETE, { groupId });
export const passportGroupSetIsDeletedAction = (value: boolean) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_SET_IS_DELETED, { value });
export const passportGroupExcludePassportsAction = (groupId: number, passportIds: number[]) =>
  action(PassportGroupActionsEnum.PASSPORT_GROUP_EXCLUDE_PASSPORTS, { groupId, passportIds });
